export const DEFAULT_RULES_COURSE_TYPES = {
  enabled: false,
  rules_course_types: {
    source: "",
    config_instructors_links: [],
  },
};
